var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "section-chart"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "div-flex"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-right txt-right"
  }, [_c('div', {
    staticClass: "dropdown-inline"
  }, [_vm.isSeries ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedType,
      expression: "selectedType"
    }],
    staticClass: "inline-dropdown",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selectedType = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "overall"
    }
  }, [_vm._v("General")]), _c('option', {
    attrs: {
      "value": "day"
    }
  }, [_vm._v("Stage")])]) : _vm._e(), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedCategory,
      expression: "selectedCategory"
    }],
    staticClass: "inline-dropdown",
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.selectedCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, _vm._l(_vm.categories, function (category, cat) {
    return _c('option', {
      key: cat,
      domProps: {
        "value": category.value
      }
    }, [_vm._v(" " + _vm._s(category.label) + " ")]);
  }), 0)])])]), _c('div', {
    staticClass: "tab-chart-wrpr"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "tab-chart"
  }, _vm._l(_vm.categoryWinners, function (heading, h) {
    return _c('button', {
      key: h,
      class: h === 0 ? ' active tablinks-btn' : 'tablinks-btn',
      on: {
        "click": function ($event) {
          _vm.openChart($event, _vm.convertToSlug(heading.heading));
        }
      }
    }, [_vm._v(" " + _vm._s(heading.heading) + " ")]);
  }), 0), _vm._l(_vm.categoryWinners, function (winners, w) {
    return _c('div', {
      key: w,
      staticClass: "tab-chartcontent",
      class: w === 0 ? ' block' : '',
      attrs: {
        "id": _vm.convertToSlug(winners.heading)
      }
    }, [_c('div', {
      staticClass: "chart-bar-wrpr"
    }, [_c('div', {
      staticClass: "bar-position-2",
      class: _vm.topThreeWinners(winners.winners)[2] ? '' : 'disable-bar'
    }, [_c('p', {
      staticClass: "prize"
    }, [_vm._v(_vm._s(_vm.topThreeWinners(winners.winners)[2]))]), _vm._m(1, true)]), _c('div', {
      staticClass: "bar-position-1",
      class: _vm.topThreeWinners(winners.winners)[1] ? '' : 'disable-bar'
    }, [_c('p', {
      staticClass: "prize"
    }, [_vm._v(_vm._s(_vm.topThreeWinners(winners.winners)[1]))]), _vm._m(2, true)]), _c('div', {
      staticClass: "bar-position-3",
      class: _vm.topThreeWinners(winners.winners)[3] ? '' : 'disable-bar'
    }, [_c('p', {
      staticClass: "prize"
    }, [_vm._v(_vm._s(_vm.topThreeWinners(winners.winners)[3]))]), _vm._m(3, true)])]), _c('div', {
      staticClass: "list-prize"
    }, [_c('ul', _vm._l(_vm.remainingWinners(winners.winners), function (rWinner, rw) {
      return _c('li', {
        key: rw
      }, [_c('span', {
        staticClass: "num"
      }, [_vm._v(_vm._s(rw.replace("winner_", "")) + " "), _c('div', {
        staticClass: "pos-number"
      }, [_vm._v("th")])]), _c('span', {
        staticClass: "money"
      }, [_vm._v(_vm._s(rWinner))])]);
    }), 0)])]);
  })], 2)])])]), _vm.showLink ? _c('EventLinks', {
    attrs: {
      "links": _vm.getLinks,
      "new_version": true
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-left"
  }, [_c('label', [_vm._v("PRIZE")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h1', [_vm._v("2"), _c('span', [_vm._v("nd")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h1', [_vm._v("1"), _c('span', [_vm._v("st")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h1', [_vm._v("3"), _c('span', [_vm._v("rd")])]);
}]

export { render, staticRenderFns }